import camelcaseKeys from 'camelcase-keys'
import { getFileURL } from '@/lib/helpers/FileURLGetter'

export class PageObjectLinkedContent {
  constructor (params = {}) {
    const { id, fileId, url, title, order, authenticated } = camelcaseKeys(params ? params : {})
    this.id = id
    this.fileId = fileId || null
    this.url = url || null
    this.title = title || null
    this.order = order || 0
    this.authenticated = authenticated || false
    // Client side properties
    this.file = fileId ? getFileURL(fileId) : null
  }
}
